import { Typography } from '@mui/material';
import { EstateWorkItem, useEstate_SendActionNeededTasksReminderMutation } from 'queries';

import { Button } from 'common/button';
import Modal from 'common/modal';
import ModalContent from 'common/modal-content';
import { NotificationSeverity, showAlert, showToast } from 'utils/notification-manager';

type Props = {
  estateWorkItem: EstateWorkItem;
  onClose: () => void;
  onReminderSent: () => void;
};

const ActionNeededTasksReminderModal = ({ estateWorkItem, onClose, onReminderSent }: Props) => {
  const portalId = estateWorkItem.estate.portalId;

  const [sendReminder, { loading: sendReminderExecuting }] =
    useEstate_SendActionNeededTasksReminderMutation({
      variables: {
        portalId,
      },
      onCompleted: () => {
        showToast({
          message: 'Success.',
          severity: NotificationSeverity.SUCCESS,
        });
        onReminderSent();
      },
      onError: (e) => {
        showAlert({
          message: 'Error sending action needed tasks reminder: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  const onSendReminderClick = () => {
    onClose();
    sendReminder();
  };

  return (
    <Modal
      setShowModal={() => {}}
      onExitClick={onClose}
      showModal={true}
      showActions={false}
      content={
        <ModalContent>
          <Typography variant="h5">Action Needed Tasks Reminder</Typography>
          <Typography>
            This action will send one reminder email for all estates in this portal if they have any
            tasks in 'Action Needed'. No email will be sent if there are no action needed tasks,
            however the date will still be updated.
          </Typography>
          <Typography>Are you sure you want to send a reminder?</Typography>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onSendReminderClick} color="secondary" disabled={sendReminderExecuting}>
            Yes, send reminder
          </Button>
        </ModalContent>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="md"
    />
  );
};

export default ActionNeededTasksReminderModal;
